import { useRef, useSyncExternalStore } from 'react';
import { createStructureSetListItemView } from '~/domain/projections/factories';
import { StructureSetListItemView } from '~/domain/projections/views';
import { domainTrace } from '~/domain/diagnostics/domainTrace';
import { useDomainStore } from './useDomainStore';
import { usePatient } from './usePatient';

interface CacheEntry {
    version: number;
    items: readonly StructureSetListItemView[];
}

export function useStructureSetListView(): readonly StructureSetListItemView[] {
    const store = useDomainStore();
    const patient = usePatient();
    const cacheRef = useRef<CacheEntry | null>(null);

    return useSyncExternalStore(store.subscribe, () => {
        const version = store.getVersion();
        if (cacheRef.current && cacheRef.current.version === version) {
            return cacheRef.current.items;
        }
        const items = patient.structureSets.map(createStructureSetListItemView);
        domainTrace.view('useStructureSetListView miss', {
            version,
            count: items.length,
        });
        cacheRef.current = { version, items };
        return items;
    });
}
